let wxUrl='http://cims.reparse.dev.goago.cn/'
let loginUlr='http://production.be.test.goago.cn/common/findFuncAuthByUser.do?sso_token=misUser1H9ET10HSBNMA74UV7HVL2CIR40010E2'
let serverDomain = ''; // 服务端域名
let logoutUrl = ''; // 退出
var host = window.location.host;
if (host.indexOf('.') != -1) {
    var hostN = host.substring(host.indexOf("."));
    if (hostN.indexOf(':') == -1) {
        serverDomain = hostN.slice(0) + '/';
    } else {
        // serverDomain = hostN.substring(hostN.indexOf(".", 1)).split(':')[0] + '/';
        serverDomain = hostN.split(':')[0] + '/';
    }
}
// let iframeUrl='http://192.168.0.200:8088'
let iframeUrl= window.location.protocol + '//fehelpcenterh5' + serverDomain;
    loginUlr= window.location.protocol + '//misi' + serverDomain;
logoutUrl= window.location.protocol + '//passport' + serverDomain;
if (window.location.origin.indexOf('gooagoo.com') > 0) {
    wxUrl = 'http://cims.reparse.gooagoo.com/';

} else if (window.location.origin.indexOf('test.goago.cn') > 0) {
    wxUrl = 'http://cims.reparse.test.goago.cn/';

} else if (window.location.origin.indexOf('dev.goago.cn') > 0) {
    wxUrl = 'http://cims.reparse.dev.goago.cn/';

}else {
    iframeUrl='http://192.168.0.200:8088'
}

// function getApiUrl(url, host = 'servicecenter') {
//     const isDev = process.env.NODE_ENV === 'development';
//     const index = window.location.host.indexOf('.');
//     const domain = window.location.host.substring(index);
//     if (isDev) {
//         return `/requestApi/${url}`;
//     }
//     return `http://${host}${domain}/${url}/`;
// }

// console.log(window.location.protocol + '//servicecenter' + serverDomain , 'window.location.protocol + \'//servicecenter\' + serverDomain')

export default{
    baseUrl: window.location.protocol + '//servicecenter' + serverDomain,
    loginUrl:loginUlr,
    logoutUrl:logoutUrl,
    // baseUrl:'http://cims.reparse.gooagoo.com/', // 线上地址
    // baseUrl:'/api/',
    authorizaURL:'',
    timeout:1000*60*30,
    iframeUrl: iframeUrl
}
